import { Vehicle } from "@tm/models"
import { ajaxAuth, mapVehicle, notUndefinedOrNull } from "@tm/utils"
import { getVehicleGsiServiceUrl } from "./helper"

export async function showVehicles(requests: string[]): Promise<Vehicle[]> {
    const response = await ajaxAuth<{ vehicles?: Vehicle[] }>({
        url: `${getVehicleGsiServiceUrl()}/ShowVehicles`,
        body: { vehicleIds: requests },
        method: "POST",
    })

    return response?.vehicles?.map(mapVehicle).filter(notUndefinedOrNull) ?? []
}
